import { z } from "zod";
import { AdminListInputSchema, adminListOutput } from "./common";

// =============
// Admin Dead Letter Event Schemas
// =============

/**
 * Admin dead letter event schema.
 */
export const AdminDeadLetterEventSchema = z.object({
	id: z.string(),
	source: z.string(),
	transactionId: z.string().nullable(),
	appId: z.string().nullable(),
	reason: z.string(),
	payload: z.string(),
	resolvedAt: z.coerce.date().nullable(),
	resolutionNotes: z.string().nullable(),
	createdAt: z.coerce.date(),
});
export type AdminDeadLetterEvent = z.infer<typeof AdminDeadLetterEventSchema>;

/**
 * Admin dead letter event list input with filters.
 */
export const AdminDeadLetterEventListInputSchema = AdminListInputSchema.extend({
	filter: z
		.object({
			source: z.string().optional(),
			appId: z.string().optional(),
			transactionId: z.string().optional(),
			resolved: z.coerce.boolean().optional(),
			createdAfter: z.coerce.date().optional(),
			createdBefore: z.coerce.date().optional(),
		})
		.optional(),
});
export type AdminDeadLetterEventListInput = z.infer<
	typeof AdminDeadLetterEventListInputSchema
>;

/**
 * Admin dead letter event list output.
 */
export const AdminDeadLetterEventListOutputSchema = adminListOutput(
	AdminDeadLetterEventSchema,
);
export type AdminDeadLetterEventListOutput = z.infer<
	typeof AdminDeadLetterEventListOutputSchema
>;
